
import { useMemo } from "react";
import { Location } from "../types";

export const useCustomMaterialLocations = (selectedLocations: Location[]) => {
  return useMemo(() => {
    // Check for 10x16m locations
    const tenBysixteenLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "10m x 16m"
    );

    // Check for 25x17m locations
    const twentyfiveByseventeenLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "25m x 17m"
    );

    // Check for 10.25x6m locations
    const tenTwentyfiveBysixLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "10.25m x 6m"
    );

    // Check for 8x6m locations
    const eightBysixLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "8m x 6m"
    );

    // Check for 16x3m locations
    const sixteenBythreeLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "16m x 3m"
    );

    // Check for 14x4m locations
    const fourteenByfourLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "14m x 4m"
    );

    // Check for 20x3m locations
    const twentyBythreeLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "20m x 3m"
    );

    // Check for 15x2m locations
    const fifteenBytwoLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "15m x 2m"
    );

    // Check for 15x3m locations
    const fifteenBythreeLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "15m x 3m"
    );

    // Check for 18x3m locations
    const eighteenBythreeLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "18m x 3m"
    );

    // Check for 4x7m locations
    const fourBysevenLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "4m x 7m"
    );

    // Check for 4x3m locations
    const fourBythreeLocations = selectedLocations.filter(location => 
      location.details?.screenDimensions === "4m x 3m"
    );

    // All locations that require custom materials
    const customMaterialLocations = [
      ...tenBysixteenLocations, 
      ...twentyfiveByseventeenLocations, 
      ...tenTwentyfiveBysixLocations, 
      ...eightBysixLocations, 
      ...sixteenBythreeLocations, 
      ...fourteenByfourLocations,
      ...twentyBythreeLocations,
      ...fifteenBytwoLocations,
      ...fifteenBythreeLocations,
      ...eighteenBythreeLocations,
      ...fourBysevenLocations,
      ...fourBythreeLocations
    ];

    return {
      tenBysixteenLocations,
      twentyfiveByseventeenLocations,
      tenTwentyfiveBysixLocations,
      eightBysixLocations,
      sixteenBythreeLocations,
      fourteenByfourLocations,
      twentyBythreeLocations,
      fifteenBytwoLocations,
      fifteenBythreeLocations,
      eighteenBythreeLocations,
      fourBysevenLocations,
      fourBythreeLocations,
      customMaterialLocations
    };
  }, [selectedLocations]);
};
